import { AttrNumber } from '../../../types/attributes';
import { CmsProduct } from '../../../types/cmsProduct';
import { PushDataLayerFn } from '../../../types/pushDataLayer';
import {
  formatAttributeItemValue,
  formatNumberWithSeparator,
} from '../../../utils/helpers';
import { ProductDetailsSectionWrapper } from './ProductDetailsSectionWrapper';
import { ProductDetailsTableKeyValueRow } from './ProductDetailsTableKeyValueRow';

type ProductDetailsAttributeListProps = {
  attributes: AttrNumber[];
  title?: string;
  /** Parent section header, used to build the accordion tracking title. */
  sectionTitle?: string;
  dropdownSection?: boolean;
  product?: CmsProduct;
  pushDataLayer?: PushDataLayerFn;
};

export const ProductDetailsAttributeList: React.FC<
  ProductDetailsAttributeListProps
> = ({
  attributes,
  dropdownSection,
  title,
  sectionTitle,
  product,
  pushDataLayer,
}) => (
  <ProductDetailsSectionWrapper
    dropdownSection={dropdownSection}
    title={title}
    sectionTitle={sectionTitle}
    product={product}
    pushDataLayer={pushDataLayer}
  >
    <div className="py-spacing/padding/y px-spacing/padding/x flex flex-col gap-spacing/gap/x">
      {attributes.map((item, index) => (
        <ProductDetailsTableKeyValueRow
          label={item.label ?? ''}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          value={formatAttributeValue(item)}
          additionalInformation={item.additional_information}
          hiddenBorder={index === attributes.length - 1}
          // Tooltip tracking title uses this list's own title (the accordion /
          // subsection, e.g. "Airmiles")
          sectionTitle={title}
          product={product}
          pushDataLayer={pushDataLayer}
        />
      ))}
    </div>
  </ProductDetailsSectionWrapper>
);

const formatAttributeValue = (attr: AttrNumber) =>
  formatNumberWithSeparator({
    value: formatAttributeItemValue(attr, true),
    thousandsSeparator: ',',
  });
